import {AddressModel} from './Address.model';
import {AddressWithContact} from '@wix/auto_sdk_ecom_current-cart';

export class ContactInfoModel {
  public address: AddressModel;

  constructor(params: ContactInfoModel) {
    this.address = params.address;
  }

  public static fromSDK(contactInfo: AddressWithContact) {
    return new ContactInfoModel({address: AddressModel.fromSDK(contactInfo?.address)});
  }
}
